module.exports = __webpack_public_path__ + "img/diagnosis.4c2b50bd.svg";